(function() {
  "use strict";

  angular
    .module("app")
    .controller("CommunitiesController", [
      "$scope",
      "$location",
      "rankingsService",
      CommunitiesController
    ]);

  function CommunitiesController($scope, $location, rankingsService) {
    // Create the app-wide selectedCommunities object
    // `communities` is the actual ID store. Accessed by getters/setters, basically
    $scope.state.selectedCommunities = {
      communities: []
    };

    $scope.state.assets = window.ccc.assetPicker;
    $scope.state.assetsById = {};
    $scope.state.assetsByName = {};
    $scope.state.assetsByGroup = {};
    $scope.state.domainsByAsset = {}; // Easily pull domain name/color for an asset

    $scope.state.selectedCommunities.addCommunity = function(communityId) {
      if (
        $scope.state.selectedCommunities.communities.indexOf(communityId) < 0
      ) {
        $scope.state.selectedCommunities.communities.push(communityId);
        $scope.rrMap.styleShape($scope.state.communitiesById[communityId].fips);
      }
    };

    $scope.state.selectedCommunities.removeCommunity = function(
      communityId,
      doPush
    ) {
      var index = $scope.state.selectedCommunities.communities.indexOf(
        communityId
      );
      if (index > -1) {
        $scope.state.selectedCommunities.communities.splice(index, 1);

        // `true` parameter forces community to style as unselected/unhovered
        // Offers better UX when a user un-selects a community from the map itself
        var community = $scope.state.communitiesById[communityId];
        $scope.rrMap.styleShape(community.fips, true);

        if (doPush) {
          // Tracks when a user removes a community
          dataLayer.push({
            event: "Community Removed",
            eventCategory: "Interactive Clicks",
            eventAction: "Community Removed|" + community.name,
            eventLabel: window.location.pathname
          });
        }
      }
    };

    $scope.state.selectedCommunities.toggleCommunity = function(communityId) {
      if ($scope.state.selectedCommunities.communityIsSelected(communityId)) {
        $scope.state.selectedCommunities.removeCommunity(communityId);
        return false;
      }
      else {
        $scope.state.selectedCommunities.addCommunity(communityId);
        return true;
      }
    };

    $scope.state.selectedCommunities.toggleCommunitiesByGroup = function(
      groupName
    ) {
      if ($scope.state.selectedCommunities.groupIsSelected(groupName)) {
        $scope.state.communitiesByGroup[groupName].forEach(function(
          val,
          ind,
          arr
        ) {
          $scope.state.selectedCommunities.removeCommunity(val);
        });
      }
      else {
        $scope.state.communitiesByGroup[groupName].forEach(function(
          val,
          ind,
          arr
        ) {
          $scope.state.selectedCommunities.addCommunity(val);
        });
      }
    };

    $scope.state.selectedCommunities.communityIsSelected = function(
      communityId,
      filteredCommunitiesByGroup
    ) {
      var selectedCommunities = $scope.state.selectedCommunities.communities;
      if (selectedCommunities.indexOf(communityId) < 0) {
        return false;
      }
      if (
        $scope.currentURL.search().cap &&
        filteredCommunitiesByGroup &&
        selectedCommunities.length > 25
      ) {
        var communityIndex = filteredCommunitiesByGroup
          .filter(function(community) {
            return selectedCommunities.indexOf(community.id) > -1;
          })
          .map(function(community) {
            return community.id;
          })
          .indexOf(communityId);

        return communityIndex > -1 && communityIndex < 5;
      }
      return true;
    };

    $scope.state.selectedCommunities.groupIsSelected = function(groupName) {
      // Quick exit if we haven't built out the requisite datasets yet
      if (!$scope.state.communitiesByGroup[groupName]) {
        return false;
      }

      var matchedArray = $scope.state.selectedCommunities.communities.filter(
        function(elem) {
          return $scope.state.communitiesByGroup[groupName].indexOf(elem) > -1;
        }
      );

      return (
        matchedArray.length == $scope.state.communitiesByGroup[groupName].length
      );
    };

    $scope.state.selectedCommunities.communitiesByGroup = function(groupName) {
      var selectedCommunitiesByGroup = $scope.state.communitiesByGroup[
        groupName
      ].filter(function(communityId) {
        return $scope.state.selectedCommunities.communityIsSelected(
          communityId
        );
      });
      return selectedCommunitiesByGroup;
    };

    // When the selected year changes, we need to default to the highest- and
    // lowest-ranked communities ONLY if the user hasn't made any selections themselves
    $scope.state.selectedCommunities.checkForUserSelections = function(before) {
      // before = communitiesByRank before `selectedYear` pulled in new data
      var after = $scope.state.communitiesByRank;

      var highestRankBefore = rankingsService.highestRanked(before);
      var lowestRankBefore = rankingsService.lowestRanked(before);

      var highestRankAfter = rankingsService.highestRanked(after);
      var lowestRankAfter = rankingsService.lowestRanked(after);

      function id(x) {
        return x.id;
      }

      function oldDefaultsAreSelected() {
        var allSelectedBefore = highestRankBefore.concat(lowestRankBefore);
        return allSelectedBefore.reduce(function(accum, cd) {
          return (
            accum && $scope.state.selectedCommunities.communityIsSelected(cd.id)
          );
        }, allSelectedBefore.length ===
          $scope.state.selectedCommunities.communities.length);
      }

      // By default, or if the only two selected communities are the old highest and
      // lowest ranked, clear the selections and select the new highest- and
      // lowest-ranking communities
      if (
        $scope.state.selectedCommunities.communities.length === 0 ||
        oldDefaultsAreSelected()
      ) {
        $scope.state.selectedCommunities.communities = [];

        highestRankAfter.concat(lowestRankAfter).forEach(function(cd) {
          $scope.state.selectedCommunities.addCommunity(cd.id);
        });

        highestRankBefore.concat(lowestRankBefore).forEach(function(cd) {
          $scope.rrMap.styleShape(cd.fips);
        });
      }
    };

    $scope.state.selectedCommunities.build = function(
      response,
      oldCommunityRanks
    ) {
      $scope.state.communityData = response;

      // Depending on what data a method has available, we might need to find a community
      // by a variety of keys. Group (Lowest Risk, Medium Risk, etc), ID, Fips ID, etc.
      // Pre-building these objects makes it easier and faster than walking the main obj.
      var sortedByGroup = {};
      var sortedById = {};
      var sortedByFips = {};

      $scope.state.communityData.map(function(community) {
        sortedByGroup[community.group] = sortedByGroup[community.group] || [];
        sortedByGroup[community.group].push(community.id);
        sortedById[community.id] = community;
        sortedByFips[community.fips] = community;
      });

      $scope.state.communitiesByGroup = sortedByGroup;
      $scope.state.communitiesById = sortedById;
      $scope.state.communitiesByFips = sortedByFips;

      var sortedCommunities = $scope.state.communityData.sort(function(a, b) {
        return a.rank - b.rank;
      });

      $scope.state.communitiesByRank = sortedCommunities;

      if ($scope.state.selectedCommunities) {
        if (
          !$scope.state.selectedCommunities.communities.length &&
          $location.search().communities
        ) {
          $location
            .search()
            .communities.split("|")
            .forEach(function(id, ind, arr) {
              $scope.state.selectedCommunities.addCommunity(+id); // coerse to int
            });
        }
        else {
          $scope.state.selectedCommunities.checkForUserSelections(
            oldCommunityRanks
          );
        }
      }
    };
  }
})();
